import { render, staticRenderFns } from "./klogo.vue?vue&type=template&id=559d4dbe&scoped=true"
import script from "./klogo.vue?vue&type=script&lang=js"
export * from "./klogo.vue?vue&type=script&lang=js"
import style0 from "./klogo.vue?vue&type=style&index=0&id=559d4dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559d4dbe",
  null
  
)

export default component.exports